/**
 * Hr api spec
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AddStatusConfigDto { 
    /**
     * Codice dello stato
     */
    code: string;
    /**
     * Tipologia: avanzamento o blocco
     */
    kind: AddStatusConfigDto.KindEnum;
}
export namespace AddStatusConfigDto {
    export const KindEnum = {
        Progress: 'progress',
        Blocked: 'blocked'
    } as const;
    export type KindEnum = typeof KindEnum[keyof typeof KindEnum];
}


